/**
 * Administrator's view of API keys and export allowances.
 *
 * There is no create call here on purpose: Premium customers mint their own
 * keys, and there is no reveal call because the server holds a hash rather
 * than the value. Revocation is the one write, for a credential that is known
 * to have leaked.
 */
import { apiFetch } from './apiClient';

export const listAllKeys = () => apiFetch('/api/market/admin/api-access/keys');

export const adminRevokeKey = (id) =>
  apiFetch(`/api/market/admin/api-access/keys/${id}`, { method: 'DELETE' });

export const getExportPolicy = () => apiFetch('/api/market/admin/api-access/exports');
